module.exports = __webpack_public_path__ + "static/media/jordyonrust.7bb4a816.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/jordyonrust.webp
// module id = 665
// module chunks = 0